import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React from 'react';
import PropTypes from 'prop-types';
import classic from '../../skins/classic';
import responsive from '../../skins/responsive';
import facelift from '../../skins/facelift';
import { st, classes } from './WixBaseUiEnvironment.st.css';
var WixBaseUiEnvironmentContext = /*#__PURE__*/React.createContext();
var WixBaseUiEnvironmentConsumer = WixBaseUiEnvironmentContext.Consumer;
/**
 * A wrapper component for an app to hold cross library global configuration such as theme, locale, etc.
 */

var WixBaseUiEnvironmentProvider = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(WixBaseUiEnvironmentProvider, _React$PureComponent);

  var _super = _createSuper(WixBaseUiEnvironmentProvider);

  function WixBaseUiEnvironmentProvider(props) {
    var _this;

    _classCallCheck(this, WixBaseUiEnvironmentProvider);

    _this = _super.call(this, props);
    _this.themes = {
      classic: classic,
      responsive: responsive,
      facelift: facelift
    };
    _this.themeRootSelectors = {
      classic: undefined,
      responsive: 'responsive-skin',
      facelift: 'classic-facelift-skin'
    };
    return _this;
  }

  _createClass(WixBaseUiEnvironmentProvider, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          dataHook = _this$props.dataHook,
          as = _this$props.as,
          children = _this$props.children,
          theme = _this$props.theme,
          madefor = _this$props.madefor,
          darkMode = _this$props.darkMode;
      return /*#__PURE__*/React.createElement(WixBaseUiEnvironmentContext.Provider, {
        value: {
          theme: theme,
          madefor: madefor,
          darkMode: darkMode
        }
      }, /*#__PURE__*/React.createElement(as, {
        className: st(classes.root, {
          madefor: madefor
        }, this.themes[theme]({
          darkMode: darkMode
        }), this.themeRootSelectors[theme]),
        'data-hook': dataHook,
        'data-theme': theme,
        'data-madefor': madefor,
        'data-dark-mode': darkMode
      }, children));
    }
  }]);

  return WixBaseUiEnvironmentProvider;
}(React.PureComponent);

WixBaseUiEnvironmentProvider.displayName = 'WixBaseUiEnvironmentProvider';
WixBaseUiEnvironmentProvider.propTypes = {
  /** Applies a data-hook HTML attribute that can be used in the tests */
  dataHook: PropTypes.string,

  /** Renders the container as the given DOM tag element */
  as: PropTypes.string,

  /** Sets the theme for base-ui components inside the provider */
  theme: PropTypes.oneOf(['classic', 'responsive', 'facelift']),

  /** When provided, sets madefor as the font for the base-ui components inside the provider */
  madefor: PropTypes.bool,

  /** When provided, sets dark mode of the current skin */
  darkMode: PropTypes.bool
};
WixBaseUiEnvironmentProvider.defaultProps = {
  theme: 'classic',
  as: 'span',
  madefor: false,
  darkMode: false
};
export { WixBaseUiEnvironmentContext, WixBaseUiEnvironmentConsumer, WixBaseUiEnvironmentProvider };